export default class Headboard {
    constructor(props) {
        Object.assign(this, props);
        if (props.disabled_at)
            this.disabled_at = new Date(props.disabled_at);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Headboards/Headboard.ts
// module id = 359
// module chunks = 0